/* @flow */

import * as React from 'react';
import { translate } from 'react-i18next';

// TODO: Not used, commented out until needed
// import type { TypePropsAssignedTo } from 'types/TypePropsAssignedTo';

import styles from './AssignedTo.module.scss';

@translate()
export default class AssignedTo extends React.Component<*> {
  render(): React.Element<*> {
    const user: string = this.props.assigned;
    const t: Function = this.props.t;

    return (
      <div className={styles['assigned-to']}>
        <h3>{this.props.title || t('general:labels.currently_assigned_to')}</h3>
        <span>{user}</span>
      </div>
    );
  }
}
